import '@/App.css';
import { Router } from '@/router';
import theme from '@/theme';
import { LOGOUT_EVENT_NAME, LOGOUT_MESSAGE_CHANNEL } from '@/utils/auth';
import { ThemeProvider } from '@/utils/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const channel = new BroadcastChannel(LOGOUT_MESSAGE_CHANNEL);

    channel.onmessage = (event) => {
      if (event.data === LOGOUT_EVENT_NAME) {
        queryClient.clear();
      }
    };

    return () => {
      channel.close();
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Router />
        <ToastContainer
          containerId="custom-toast-container"
          position="top-center"
          autoClose={2500}
          hideProgressBar
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
